import { LazoPaths } from "./LazoPaths";

export const PUBLIC_PATHS: string[] = [LazoPaths.ONBOARDING, LazoPaths.LOGIN, LazoPaths.TERMS_AND_POLICIES, LazoPaths.REDIRECT];
